import React, { Component, Fragment, lazy, Suspense } from 'react';

import { ErrorBoundary } from 'app/common/components/ErrorBoundary';
import { GlobalErrorHandler } from 'app/common/components/GlobalErrorHandler';

import * as singleSpa from 'single-spa';
import * as ClassicApp from 'singlespa/apps/classic';

import { domReady, initializeLayers } from './doc-init';

import Perf, { PerfKeys } from 'app/common/debug/perf';
import { isGammaHeaderEnabled } from 'app/common/lib/feature-flag-client';

import { ComponentWrapper } from 'app/gamma/src/components/ComponentWrapper';
import LayerManager from 'app/gamma/src/components/layer-manager';
import Alerts from 'app/gamma/src/components/alerts';
import Header from 'app/gamma/src/components/header';
import LogoutTrigger from 'app/gamma/src/components/logout-trigger';
import Overlays from 'app/gamma/src/components/overlays';
import BoardsMenu from 'app/gamma/src/components/popovers/boards-menu';

export class Chrome extends Component {
  constructor(props) {
    super(props);

    domReady();
  }

  componentDidMount() {
    initializeLayers();
    // Tell single-spa that you're ready for it to mount your application to the DOM
    ClassicApp.setElem(document.getElementById('chrome-container'));
    singleSpa.start();
    Perf.stopMeasurement(PerfKeys.FIRST_RENDER);
  }

  render() {
    const isGammaHeader = isGammaHeaderEnabled();

    return (
      <ErrorBoundary errorHandlerComponent={GlobalErrorHandler}>
        <LayerManager>
          {isGammaHeader ? (
            <ComponentWrapper>
              <BoardsMenu />
            </ComponentWrapper>
          ) : (
            <div id="boards-drawer" />
          )}
          <p id="notification" />
          <div id="surface">
            {isGammaHeader ? (
              <ComponentWrapper>
                <Header />
              </ComponentWrapper>
            ) : (
              <div id="header" />
            )}
            <div id="banners" />
            <div id="content" />
            <div id="footer">
              <div id="contact-us" style={{ display: 'none' }}>
                If you're having trouble loading Trello,{' '}
                <a
                  href="http://help.trello.com/article/736-troubleshooting-browser-issues-with-trello"
                  target="support"
                >
                  check out our troubleshooting guide
                </a>{' '}
                or{' '}
                <a
                  href="/contact?context=load-failure&source=from%20in%20app%20footer"
                  target="contact"
                >
                  contact us
                </a>!
              </div>
              <div id="footer-chrome" style={{ display: 'none' }} />
            </div>
          </div>
          {isGammaHeader && (
            <ComponentWrapper>
              <Fragment>
                <Alerts />
                <Overlays />
                <LogoutTrigger />
              </Fragment>
            </ComponentWrapper>
          )}
        </LayerManager>
        <div className="window-overlay">
          <div className="window">
            <a className="focus-dummy" href="#" />
            <div className="window-wrapper" />
          </div>
        </div>
        <div className="pop-over" />
        <div className="tooltip-container" />
        <div id="clipboard-container" />
      </ErrorBoundary>
    );
  }
}



// WEBPACK FOOTER //
// ./app/scripts/views/chrome/Chrome.js